<template>
  <section>
    <PageTitle title="Nawiążmy kontakt" />
    <div
      class="container px-4 pt-32 mx-auto text-center sm:px-0 lg:px-0 xl:px-0 2xl:px-64 md:pt-40 lg:pt-40 2xl:pt-56 sm:text-left"
    >
      <main>
        <div class="container px-5 pb-24 mx-auto">
          <div class="flex flex-col w-full mb-20 text-center">
            <h1 class="mb-4 text-2xl font-medium text-gray-900 sm:text-3xl title-font">Wybierz kontakt</h1>
            <p class="mx-auto text-base leading-relaxed lg:w-2/3">
              Dbamy o to, by nasi Klienci zawsze byli obsługiwani na najwyższym poziomie. Indywidualne podejście to coś,
              co wyróżnia nas wśród konkurencji.
            </p>
          </div>
          <div class="flex flex-wrap -m-2">
            <div class="w-full p-2 lg:w-1/3 md:w-1/2">
              <div class="flex items-center h-full p-4 border border-gray-200 rounded-lg">
                <img
                  alt="team"
                  class="flex-shrink-0 object-cover object-center w-16 h-16 mr-4 bg-gray-100 rounded-full"
                  src="https://dummyimage.com/80x80"
                />
                <div class="flex-grow">
                  <h2 class="font-medium text-gray-900 title-font">Biuro - Email</h2>
                  <a href="mailto:biuro@haft-poznan.pl" class="text-blue-500">biuro@haft-poznan.pl</a>
                </div>
              </div>
            </div>
            <div class="w-full p-2 lg:w-1/3 md:w-1/2">
              <div class="flex items-center h-full p-4 border border-gray-200 rounded-lg">
                <img
                  alt="team"
                  class="flex-shrink-0 object-cover object-center w-16 h-16 mr-4 bg-gray-100 rounded-full"
                  src="https://dummyimage.com/84x84"
                />
                <div class="flex-grow">
                  <h2 class="font-medium text-gray-900 title-font">Biuro - Telefon</h2>
                  <a href="tel:48609020455" class="text-blue-500">biuro@haft-poznan.pl</a>
                </div>
              </div>
            </div>
            <div class="w-full p-2 lg:w-1/3 md:w-1/2">
              <div class="flex items-center h-full p-4 border border-gray-200 rounded-lg">
                <img
                  alt="team"
                  class="flex-shrink-0 object-cover object-center w-16 h-16 mr-4 bg-gray-100 rounded-full"
                  src="https://dummyimage.com/88x88"
                />
                <div class="flex-grow">
                  <h2 class="font-medium text-gray-900 title-font">Biuro - Adres</h2>
                  <p class="text-blue-500">
                    ul. Lednicka 10
                    <br />60-413 Poznań, Poland
                  </p>
                </div>
              </div>
            </div>
            <div class="w-full p-2 lg:w-1/3 md:w-1/2">
              <div class="flex items-center h-full p-4 border border-gray-200 rounded-lg">
                <img
                  alt="team"
                  class="flex-shrink-0 object-cover object-center w-16 h-16 mr-4 bg-gray-100 rounded-full"
                  src="https://dummyimage.com/80x80"
                />
                <div class="flex-grow">
                  <h2 class="font-medium text-gray-900 title-font">Hafciarnia - Email</h2>
                  <a href="mailto:hafciarnia@haft-poznan.pl" class="text-blue-500">hafciarnia@haft-poznan.pl</a>
                </div>
              </div>
            </div>
            <div class="w-full p-2 lg:w-1/3 md:w-1/2">
              <div class="flex items-center h-full p-4 border border-gray-200 rounded-lg">
                <img
                  alt="team"
                  class="flex-shrink-0 object-cover object-center w-16 h-16 mr-4 bg-gray-100 rounded-full"
                  src="https://dummyimage.com/84x84"
                />
                <div class="flex-grow">
                  <h2 class="font-medium text-gray-900 title-font">Hafciarnia - Telefon</h2>
                  <a href="tel:48609020455" class="text-blue-500">+48 616 527 101</a>
                  <br />
                  <a href="tel:+48663985010" class="text-blue-500">+48 663 985 010</a>
                </div>
              </div>
            </div>
            <div class="w-full p-2 lg:w-1/3 md:w-1/2">
              <div class="flex items-center h-full p-4 border border-gray-200 rounded-lg">
                <img
                  alt="team"
                  class="flex-shrink-0 object-cover object-center w-16 h-16 mr-4 bg-gray-100 rounded-full"
                  src="https://dummyimage.com/84x84"
                />
                <div class="flex-grow">
                  <h2 class="font-medium text-gray-900 title-font">Hafciarnia - Telefon</h2>
                  <a href="tel:48609020455" class="text-blue-500">Hafciarnia@haft-poznan.pl</a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="relative text-gray-700 body-font">
          <div class="container flex flex-wrap px-5 py-12 mx-auto sm:flex-no-wrap">
            <div
              class="relative flex items-end justify-start p-10 overflow-hidden bg-gray-300 rounded-lg lg:w-2/3 md:w-1/2 sm:mr-10"
            >
              <iframe
                width="100%"
                height="100%"
                class="absolute inset-0"
                frameborder="0"
                title="map"
                marginheight="0"
                marginwidth="0"
                scrolling="no"
                src="https://maps.google.com/maps?q=ul.%20Szamotulska%2067,%2062-081%20Baranowo,%20Poland&t=&z=13&ie=UTF8&iwloc=&output=embed"
                style="filter: grayscale(1) contrast(1.2) opacity(0.4);"
              ></iframe>
              <div class="relative flex flex-wrap py-6 bg-white">
                <div class="px-6 lg:w-1/2">
                  <h2 class="text-sm font-medium tracking-widest text-gray-900 title-font">ADRES</h2>
                  <p class="leading-relaxed">
                    ul. Szamotulska 67,<br />
                    62-081 Baranowo, Poland
                  </p>
                </div>
                <div class="px-6 mt-4 lg:w-1/2 lg:mt-0">
                  <h2 class="text-sm font-medium tracking-widest text-gray-900 title-font">EMAIL</h2>
                  <a class="leading-relaxed text-blue-500" href="mailto:biuro@haft-poznan.pl">biuro@haft-poznan.pl</a>
                  <h2 class="mt-4 text-sm font-medium tracking-widest text-gray-900 title-font">Telefon</h2>
                  <p class="leading-relaxed">+48 609 020 455</p>
                </div>
              </div>
            </div>
            <div class="flex flex-col w-full mt-8 bg-white lg:w-1/3 md:w-1/2 md:ml-auto md:py-8 md:mt-0">
              <h2 class="mb-1 text-lg font-medium text-gray-900 title-font">Wyślij wiadomość</h2>
              <input
                class="px-4 py-2 mb-4 text-base bg-white border border-gray-400 rounded focus:outline-none focus:border-indigo-500"
                placeholder="Nazwa"
                type="text"
              />
              <input
                class="px-4 py-2 mb-4 text-base bg-white border border-gray-400 rounded focus:outline-none focus:border-indigo-500"
                placeholder="Adres email"
                type="email"
              />
              <textarea
                class="h-32 px-4 py-2 mb-4 text-base bg-white border border-gray-400 rounded resize-none focus:outline-none focus:border-indigo-500"
                placeholder="Wiadomość"
              ></textarea>
              <button
                class="px-6 py-2 text-lg text-white bg-blue-500 border-0 rounded focus:outline-none hover:bg-blue-600 transform motion-reduce:transform-none hover:-translate-y-1 transition ease-in-out duration-300"
              >
                Wyślij
              </button>
              <p class="mt-3 text-xs text-gray-500"></p>
            </div>
          </div>
        </div>
      </main>
    </div>
    <PageTitle title="Nasza oferta" />
  </section>
</template>

<script>
import PageTitle from "../components/PageTitle";
export default {
  name: "Contact",
  components: {
    PageTitle,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped></style>
